import * as React from "react";
import {IconProps, getIconSize} from "./IconInterface"

export const IconExclamation = ({
  className,
  size = "md",
  stroke = "#1C1F2B"
}: IconProps) => {
  const sizeOption = getIconSize(size)
  return (
    <svg
    className={`${className} ${sizeOption}`}
    width={24}
    height={24}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      stroke={stroke}
      transform="translate(3 4)"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M9 6v2m-6.928 8h13.856c1.54 0 2.502-1.667 1.732-3L10.732 1C9.962-.333 8.038-.333 7.268 1L.34 13c-.77 1.333.192 3 1.732 3Z"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
      <circle fill="#1C1F2B" cx={9} cy={11} r={1} />
    </g>
  </svg>
  )
}
